import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Email', prop: 'email' },
  { title: 'Roles', prop: 'roles', format: 'array', sortable: false },
  { title: 'Groups', prop: 'memberships_count', sortable: false },
  { title: 'Coachings', prop: 'coachings_count', sortable: false },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' }
]

const defaults = {
  order: [
    { column: 'created_at', direction: 'asc' }
  ]
}

const filters = [
  { name: 'Filter by name', prop: 'filters.fullname_ilike', type: 'text', enabled: true },
  { name: 'Filter by email', prop: 'filters.email_ilike', type: 'text', enabled: true },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const Users = (props) => (
  <List
    title='Users'
    apiPath='admin/users'
    columns={columns}
    filters={filters}
    defaults={defaults}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    buildMenuItems={menuItems}
    withExport
  />
)

export default Users
